import { ProgramAvailablity } from "src/enums";
import { ProgramInfo, ProgramMessage, Stream, PlayerUrl, Promotions } from "src/models";

export type ProgramDetail = {
    loading: boolean;
    info?: ProgramInfo;
    id?: number;
    currentStream?: Stream;
    availability?: ProgramAvailablity;
    message: ProgramMessage;
    player?: PlayerUrl;
    reporting: boolean;
    killSessionId: string[];
    ipChecking: boolean;
    promotion?: Promotions;
};

export const ProgramDetailInitialState: ProgramDetail = {
    reporting: false,
    loading: false,
    message: {
        hasMessage: false
    },
    killSessionId: [],
    ipChecking: false,
};